import React from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import { useEffect } from "react";
// import CircularProgress from '@mui/material/CircularProgress';
// or
// import { CircularProgress } from '@mui/material';
// import CircularProgress from '@mui/material/CircularProgress';


const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

export default function TransitionsModal(props) {
  const classes = useStyles();
  const { showModel, setModelShow, message, header, _onSubmit, result, showResult, showscore, updateFlag, headerMessage, _setOnReload, _setWindowSwitch, setIsWindowSwitched } = props;

  const handleClose = () => {
    // setOnReload(false)
    if (header === 'Violation of Rule !!!') {
      // window.onbeforeunload = (event) =>{
      //   // event.preventDefault();
      // }
      window.onbeforeunload = function () {
        return null;  // return null to avoid pop up
      }
      // onSubmit('111');
      //closeModal();
      window.location.reload('/dashboard')
      setModelShow(false);

    } else if (headerMessage) {
      window.location.reload(false);
    } else {
      setModelShow(false);
    }
  };

  useEffect(() => {
    window.onbeforeunload = function (event) {
      event.preventDefault();
    }
  });

  return (
    <div>

      <Modal
        disableEnforceFocus={true}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={showModel}
        //onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={showModel}>
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            {header ?
              <div style={{ textAlign: "center" }}>
                <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px", lineHeight: "initial" }} dangerouslySetInnerHTML={{ __html: header }} />
              </div>
              :
              headerMessage ?
                <div style={{ textAlign: "center" }}>
                  <h3 id="transition-modal-title" style={{ color: '#6f2981', marginBottom: "30px", lineHeight: "initial" }} dangerouslySetInnerHTML={{ __html: headerMessage }} />
                </div>
                : ''
            }
            {message ?
              <p id="transition-modal-description" dangerouslySetInnerHTML={{ __html: message }}>
                {/* {message} */}
              </p> : ''}
            {header === 'Violation of Rule !!!' && (showscore || !updateFlag) ? (result !== undefined && result !== null && showResult
              ? <div className="form-group" style={{ textAlign: "center" }}>
                <p style={{ fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: result }}></p>
                <ul className="list-inline">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <li><a href="#" className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={() => handleClose()} ><strong>Close</strong></a></li>
                </ul>
              </div> :
              <>
                {/* <CircularProgress variant="determinate" value={50} /> */}

                <p>
                  Your result is being processed. Please <span style={{ color: 'red' }}><strong>DO NOT </strong></span>refresh this page or close the browser, else your test result will be considered <span style={{ color: 'red' }}><strong>INVALID.</strong></span>
                </p></>) : <div className="form-group" style={{ textAlign: "center" }}>
              <ul className="list-inline">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <li><a href="#" className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={() => handleClose()} ><strong>Close</strong></a></li>
              </ul>
            </div>}
            {/* <div className="form-group" style={{textAlign:"center"}}>
					      	<ul className="list-inline btn-list">
                <li><a className="btn btn-blue" style={{borderRadius:"10px"}} onClick={handleClose} >
                <strong>Close</strong>
            </a>
                </li>

                </ul>
                </div> */}

          </div>
        </Fade>
      </Modal>
    </div>
  );
}
